import ServiceCRUD from 'services/ServiceImageUpload';

class ImageService extends ServiceCRUD {
    constructor() {
        super(`/src/public/img`);
    }
}

export default new ImageService();
